import { FormGroup } from "@angular/forms";

/**
 * Provides utility methods for working with forms.
 */
export class FormUtility
{
	/**
	 * Resets the specified form group.
	 * @param formGroup The form group to reset.
	 * @param values The values to populate the form. (Optional)
	 * @see {@link FormGroup.reset}
	 */
	public static reset(formGroup: FormGroup, values?: any): void
	{
		formGroup.reset(values);
		Object.keys(formGroup?.controls).forEach(key => {
			formGroup?.controls[key]?.setErrors(null);
  			formGroup?.controls[key]?.updateValueAndValidity();	// Update validity after resetting values.
		})
	}

	/**
	 * Clears the value for the specified form control.
	 * @param formGroup The form group containing the control to update.
	 * @param key The name of the control to clear.
	 */
	public static clear(formGroup: FormGroup, key: string): void
	{
		formGroup?.get(key)?.setValue('');
		formGroup?.markAsDirty();
	}

	/**
	 * Returns a value indicating if the specified form control has a value.
	 * @param formGroup The form group containing the control to check.
	 * @param key The name of the control to check for a value.
	 * @returns If the control has a value, `true`; otherwise, `false`.
	 */
	public static hasValue(formGroup: FormGroup, key: string): boolean
	{
		return formGroup?.get(key)?.value != undefined
			&& formGroup?.get(key)?.value != '';
	}
}